class Addtocartbtn extends HTMLElement {
  constructor() {
    super()
    this.button = this
    this.button.addEventListener('click',this.fnAddtocart.bind(this))
  }
  fnAddtocart(event){
    let varaintId = parseInt(this.getAttribute('data-variant-id'));
    this.button.classList.add('btn--loading')
    let quantity = this.getAttribute('data-quantity')? parseInt(this.getAttribute('data-quantity')) :1;
    let formData = {
      id:varaintId,
      quantity:quantity
    }
      fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(response => {
          // document.dispatchEvent(new Event('ajaxProduct:added'))
          if(window.SLIDECART){
            document.dispatchEvent(new Event('ajaxProduct:added'));
            window.SLIDECART_UPDATE();
            window.SLIDECART_OPEN();
            
          }
          else{
            document.dispatchEvent(new Event('ajaxProduct:added'))
            
          }
          this.button.classList.remove('btn--loading');
          return response.json();
        })
        .catch((error) => {
          this.button.classList.remove('btn--loading');
          console.error('Error:', error);
        });
  }
}
customElements.define("add-to-cart", Addtocartbtn);

// product Description Readmore Readless functionality

document.addEventListener("DOMContentLoaded", (event) => {
  const readmoreButton = document.getElementById('pr-de-readmore');
  const readlessButton = document.getElementById('pr-de-readless');
  const short_description = document.querySelector('.short_description');
  const full_description = document.querySelector('.full_description ');
  if(readmoreButton){
  readmoreButton.addEventListener('click',function(event){
    event.preventDefault();
    short_description.classList.add('hide');
    full_description.classList.remove('hide')
  })
  readlessButton.addEventListener('click',function(event){
    event.preventDefault();
    short_description.classList.remove('hide');
    full_description.classList.add('hide')
  });
  }

  let reviewTrigger = document.querySelector('[data-scroll-to="stamped-main-widget"]')
  if(reviewTrigger){
    reviewTrigger.addEventListener('click',function(){
      
      let headerHeight = document.getElementById('SiteHeader').offsetHeight
      let mainWidget = document.getElementById('stamped-main-widget').offsetTop;
      let finalScroll = mainWidget - headerHeight;
      window.scrollTo({
            top: finalScroll,
            behavior: "smooth"
        }); 
    });
  }
});

// Gobi Player Embed in section
// document.addEventListener("DOMContentLoaded", (event) => {
  
//   let gobistories = document.querySelectorAll('[data-story-id]');
  
//   if(gobistories){
      
//     Array.from(gobistories).forEach(function(story,index){
//       console.log(index)
//       let slider = story.getAttribute('data-slider');
//       let storyId = story.getAttribute('data-story-id');
//       let targetId = story.getAttribute('id');
//       fetch(`https://api.gobistories.com/api/v5/renders/${storyId}`)
//       .then((data)=>(data.json()))
//       .then((data)=>{
//         let image = data.coverUrl
//         story.querySelector('img').setAttribute("src",image);
//         console.log(index == (gobistories.length - 1))
//            if(index == (gobistories.length - 1)){
      
        
//         window.dispatchEvent(new Event('resize'))
//       }
//       });
//     })
//     }
// });


 
document.addEventListener("DOMContentLoaded", (event) => {
  let gobisliders = document.querySelectorAll('[data-gobi-slider]');
  if(gobisliders){
    Array.from(gobisliders).forEach((gobislide,index)=>{
      let sectionId = gobislide.getAttribute('id')
      let gobicarousel = new Flickity(`#${sectionId}`, {
        cellAlign: 'left',
        contain: true,
        wrapAround: true,
        groupCells: true,
        prevNextButtons: true,
        pageDots: false
      });
      window.AOS.refresh()
      window.addEventListener("resize", function(){
        gobicarousel.resize()
      });
    })
  }
  window.dispatchEvent(new Event('resize'));
});
class GobiPlaybutton extends HTMLElement{
  constructor(){
    super();
    this.playId = this.getAttribute('data-play-id')
    this.addEventListener('click',function(event){
      this.playGoby(event)
    }.bind(this))
  }
  playGoby(){
        gobi.openPopup(this.playId)
  }
}
  
customElements.define("gobi-play", GobiPlaybutton);





// Home page sticky baar
const elements = document.querySelectorAll(".page-content.page-content--product");
  const stickyBars = document.querySelectorAll(".sticky-bar-product");
 
  function checkElementsAtTop() {
    let activeId = null;
 
    elements.forEach(el => {
      const rect = el.getBoundingClientRect();
 
      // First element whose top is at/above 0 but still visible
      if (rect.top <= 0 && rect.bottom > 0 && activeId === null) {
        activeId = el.getAttribute("data-id");
      }
    });
 
    if (activeId) {
      // Remove active from all
      stickyBars.forEach(bar => bar.classList.remove("active-sticky"));
      // Add active to the matched one
      const target = document.querySelector('.sticky-bar-product[data-id="' + activeId + '"]');
      if (target) {
        target.classList.add("active-sticky");
      }
    }
  }
 
  // Run on page load
  checkElementsAtTop();
 
  // Run on scroll
  window.addEventListener("scroll", checkElementsAtTop);
 
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.add-cart').forEach(button => {
      button.addEventListener('click', function(e) {
          e.preventDefault();
          document.querySelector('.payment-buttons .add-to-cart')?.click(); 
      });
    });
  });